module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dUS1y"))).then(() => module.bundle.root('lKlEc'));